module.exports = __webpack_public_path__ + "static/img/best_game.3de39570.png";